import React, { useContext, useRef, useEffect } from 'react';
import { Bell, X, Trash2, Settings } from 'lucide-react';
import { Link } from 'react-router-dom';
import { NotificationsContext } from './Layout';

export default function NotificationBell() {
  const {
    notifications,
    showNotifications,
    setShowNotifications,
    unreadCount,
    handleNotificationClick,
    clearAllNotifications
  } = useContext(NotificationsContext);

  const dropdownRef = useRef(null);

  // Click outside handler
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowNotifications(false);
      }
    }

    if (showNotifications) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }
  }, [showNotifications, setShowNotifications]);

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setShowNotifications(!showNotifications)}
        data-testid="notifications-button"
        className="relative p-2 rounded-full transition-colors"
        style={{ background: 'var(--surface)', border: '1px solid var(--border)', color: 'var(--text)' }}
      >
        <Bell className="w-6 h-6" />
        {unreadCount > 0 && (
          <span
            className="absolute top-0 right-0 w-5 h-5 text-white text-xs rounded-full flex items-center justify-center font-semibold"
            style={{ background: 'var(--danger)' }}
          >
            {unreadCount}
          </span>
        )}
      </button>
      {showNotifications && (
        <>
          {/* Backdrop for mobile */}
          <div 
            className="fixed inset-0 z-[45] lg:hidden"
            onClick={() => setShowNotifications(false)}
          />
          {/* Dropdown */}
          <div
            className="absolute right-0 mt-2 w-80 rounded-xl shadow-xl overflow-hidden z-50"
            style={{ background: 'var(--surface)', border: '1px solid var(--border)', color: 'var(--text)' }}
            data-testid="notifications-dropdown"
          >
            <div className="p-4 flex items-center justify-between" style={{ borderBottom: '1px solid var(--border)' }}>
              <h3 className="font-semibold">Bildirimler</h3>
              <div className="flex items-center space-x-2">
                {notifications.length > 0 && (
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      clearAllNotifications();
                    }}
                    className="ox-text-muted hover:text-red-500 transition-colors"
                    title="Tümünü Temizle"
                  >
                    <Trash2 className="w-5 h-5" />
                  </button>
                )}
                <Link
                  to="/notifications/settings"
                  onClick={() => setShowNotifications(false)}
                  className="ox-text-muted hover:text-[var(--text)] transition-colors"
                  title="Bildirim Ayarları"
                >
                  <Settings className="w-5 h-5" />
                </Link>
                <button
                  onClick={() => setShowNotifications(false)}
                  className="ox-text-muted hover:text-[var(--text)]"
                >
                  <X className="w-5 h-5" />
                </button>
              </div>
            </div>
            <div className="max-h-96 overflow-y-auto ox-scroll">
              {notifications.length === 0 ? (
                <p className="p-4 text-center ox-text-muted">Bildirim yok</p>
              ) : (
                notifications.map((notif) => (
                  <div
                    key={notif.id}
                    onClick={() => handleNotificationClick(notif)}
                    className="p-4 cursor-pointer transition-colors ox-row-hover"
                    style={{
                      borderBottom: '1px solid var(--border)',
                      background: !notif.read ? 'var(--accent-weak)' : 'transparent',
                    }}
                  >
                    <p className="text-sm" style={{ color: 'var(--text)' }}>{notif.message}</p>
                    <p className="text-xs mt-1 ox-text-dim">
                      {new Date(notif.createdAt).toLocaleString('tr-TR')}
                    </p>
                  </div>
                ))
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
}
